// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1l19I","support":"style_support__1rRee","logo":"style_logo__125Tr"};